<template>
  <v-content>
    <Header title="Thank you for choosing NBM Solicitors">
      <span>We have successfully received your instruction request and we’re now busy processing it. Please check your email for confirmation and a copy of your quotation should be waiting for you in your email inbox. ( Let us know if not, and we will send you another copy.)</span>
      <v-divider class="my-3"></v-divider>
      <div class="title">Download a copy</div>
      <v-btn :href="computedUrl" target="_blank">
        <v-icon>print</v-icon>Download
      </v-btn>
    </Header>
    <v-container>
      <v-alert :value="true" type="info">
        The reference for this case is:
        <strong>{{$route.params.quoteId}}</strong>. Please keep a note safe, for your records.
      </v-alert>
      <v-card>
        <v-card-text>When we have processed your request, we will contact you to gather more information relating to your matter. We will then provide you with a username and password to log in to the case tracking system, so you can track updates and contact us easily.</v-card-text>
        <v-card-text>
          We hope to exceed your expectations,and look forward to working with you. Please let us know if we can help further, just
          <a
            href="https://nbmlaw.co.uk/contact.htm"
          >contact us</a> anytime.
        </v-card-text>
        <v-card-actions>
          <v-btn href="https://nbmlaw.co.uk/" large>
            <v-icon>home</v-icon>Return to home
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-container>
  </v-content>
</template>

<script>
import Header from "@/components/Header";
export default {
  name: "Thanks",
  components: { Header },
  computed: {
    computedUrl() {
      return `${process.env.VUE_APP_CT_URL}/cors/open/sales/quotes/${this.$route.params.quoteId}/pdf/${this.$route.params.salesUid}`;
    }
  }
};
</script>

<style>
</style>